export const REPLACED_BLOB_VARIABLE_PLACEHOLDER = '==stripped blob data==';

export const PATH_HEADER = 'rf-path';
export const REQUEST_SOURCE_HEADER = 'rf-request-source';
export const SERVICES_CLIENT_LOGGER_CONTEXT_IDENTIFIER = 'services/client';
